export default "__VITE_ASSET__Dl$M_ASa__"